import { MRT_ColumnDef } from "material-react-table"
import { useMemo } from "react"

interface UseTableColumnsResumenClientesRetiradosSoftnetProps {
    pagination?: { pageIndex: number; pageSize: number };
}

export const useTableColumnsResumenClientesRetiradosSoftnet = (props?: UseTableColumnsResumenClientesRetiradosSoftnetProps) => {
    const { pagination } = props || {};

    const columnBase = useMemo<MRT_ColumnDef<any>[]>(() => [
        {
            accessorKey: 'numero',
            header: '#',
            size: 60,
            enableColumnFilter: false,
            Cell: ({ row }) => {
                // Calcular número absoluto basado en la página actual
                const baseNumber = pagination ? (pagination.pageIndex * pagination.pageSize) : 0;
                return baseNumber + row.index + 1;
            },
        },
        {
            accessorKey: 'mes',
            header: 'MES',
            size: 100,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'registros',
            header: 'CANTIDAD',
            size: 100,
            Cell: ({ cell }) => cell.getValue<number>() || '-',
        },
        {
            accessorKey: 'Ciudad',
            header: 'CIUDAD',
            size: 250,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'tipo_servicio',
            header: 'TIPO SERVICIO',
            size: 250,
            Cell: ({ cell }) => cell.getValue<string>() || '-',
        },
        {
            accessorKey: 'motivo',
            header: 'MOTIVO',
            size: 250,
            Cell: ({ cell }) => cell.getValue<string>() || 'NO DEFINIDO',
        },
    ], [pagination]);

    return {
        columnBase
    }
}
